import React, { useState } from "react";
import styled from "styled-components";
import GrTitle, { Title } from "../components/BgTitle";
import FaqsQuestions from "../components/faqs/FaqsQuestions";
import colors from "../constatns/colors";
import useWindowDimensions from "../constatns/size";

import "../styles/home.css";

function FAQS() {
    const { width, height } = useWindowDimensions();
    const [section, setSection] = useState(1);
  return (
      <div id="faqs">
            <GrTitle bgTitle={"FAQS"} />
            <Title title={"FAQS"} />
        <Container width={width} height={height} >
            <InnerContainer style={{flexDirection:  "row", flexWrap: width <= 768 ? "wrap" : "nowrap", alignItems: "flex-start", alignSelf: width <= 768 ? "flex-start" : "center"}}>
                    <Btn onClick={()=>{setSection(1)}} color={ section === 1 ? colors.btnPrimary : colors.grey}>
                        GearChain
                    </Btn>
                    <Btn onClick={()=>{setSection(2)}} color={ section === 2 ? colors.btnPrimary : colors.grey}>
                        DApp
                    </Btn>
                    <Btn onClick={()=>{setSection(3)}} color={ section === 3 ? colors.btnPrimary : colors.grey}>
                        Token
                    </Btn>
                    <Btn onClick={()=>{setSection(4)}} color={ section === 4 ? colors.btnPrimary : colors.grey}>
                        Presale
                    </Btn>
                    <Btn onClick={()=>{setSection(5)}} color={ section === 5 ? colors.btnPrimary : colors.grey}>
                        Communication
                    </Btn>
            </InnerContainer>
            <InnerContainer style={{flexDirection: "column", width: "100%"}}>
                { section === 1 &&
                    <FaqsQuestions
                        firstQuestion={"What is GearChain?"}
                        firstDescription={"GearChain is a zero code and zero cost blockchain app builder for supply chain management applications. There is no upfront investment or programming required to build a custom inventory app for your supply chain. The goal of GearChain is to alter the current status quo and establish an efficient, economical supply chain protocol that is accessible to everyone. This is achieved by building a trustless protocol and a decentralized ecosystem by leveraging multiple blockchains to create a reliable inventory system in which all the intermediaries can participate."}
                        secondQuestion={"Why are our GearChain so special?"}
                        secondDescription={"It's the world's first zero-code and zero-cost blockchain app builder platform for the SCM. It has built in barcode scanning and uses mobile phones as an IoT device. Our permissionless blockchain with privacy protection and invitation-only permission control can guarantee transparency, ongoing innovation, and address the privacy concerns of businesses. Moreover, GearChain leverages NFT, GSP, and Google Sheets in order to provide a broader range of uses."}
                        thirdQuestion={"Where is GearChain located?"}
                        thirdDescription={"GearChain is based in San Jose, CA in the United States."}
                        fourthQuestion={"Who is behind GearChain?"}
                        fourthDescription={"GearChain was founded by Harry SY Jung. GearChain is originated from GEAR NBS with proven concept and the founders bring together with years of professional experience, have successfully founded various companies, and bring excellent expertise from the industry and IT sectors."}
                
                    />
                }
                { section === 2 &&
                    <FaqsQuestions
                        firstQuestion={"How to use the GearChain dApp?"}
                        firstDescription={"The GearChain DApp can be installed on both Android and iOS devices for inventory management use cases. Users can build a customizable form with available form fields designed specifically for supply chain needs. The result is a network of verification services that communicate with each other through our layer 2 solutions. The platform is versatile and user-friendly, so developers can create apps without any expertise in blockchain technology."}
                        secondQuestion={"When will the platform be online?"}
                        secondDescription={"The beta version of the platform will start in Q1-2 2023. (Pending)"}
                        thirdQuestion={"Who will the platform be used by?"}
                        thirdDescription={"The GearChain app is primarily used in the B2B sector, but can also be used for household or individual inventory management in B2C."}
                        fourthQuestion={"Where will the platform be hosted?"}
                        fourthDescription={"The platform is hosted on Google Firebase and offers almost infinite scaling possibilities."}
                        fifthQuestion={"Is the platform subject to a fee?"}
                        fifthDescription={"Our DApp is usage based and can start free. Then a user purchases credits (tokens) for the barcode scanning entry submission. "}
                    
                />
                }
                { section === 3 &&
                    <FaqsQuestions
                        firstQuestion={"What are the GearChain Token?"}
                        firstDescription={"GearChain is all set to be a disruptor in the inventory management landscape with an innovative business model fueled by the GearChain tokens. "}
                        secondQuestion={"When will the GearChain Token be launched?"}
                        secondDescription={"Due to the bear market situation, we will launch the GearChain Token (GEGA) in 2023 - 2024"}
                        thirdQuestion={"On which chain will the GearChain token run?"}
                        thirdDescription={"The token will run on a blockchain supporting smart contracts with multi-chain capabilities. The first and main chain will be on Algorand mainnet. With multichain capabilities, we can adopt another mainnet and/or commit to different mainnet down the road. "}
                        fourthQuestion={"What can I do with the GearChain token?"}
                        fourthDescription={"The GearChain token can be used as a payment method for the services offered by GearChain DApp platform."}
                        fifthQuestion={"Where can I find more information about the token?"}
                        fifthDescription={"In our whitepaper, the terms and possibilities of our token are described in more detail."}
                    />
                }
                { section === 4 &&
                    <FaqsQuestions
                        firstQuestion={"How can I participate in the private sale and/or presale?"}
                        firstDescription={"Once you apply for the whitelist via the web form, our team will contact you to verify your information. If you are applicable, you will have a chance to participate in the private sale. The GearChain token is limited. It is offered on a first come, first serve basis."}
                        secondQuestion={"Which currency can be used to buy GearChain Tokens?"}
                        secondDescription={"GearChain Tokens can be purchased with Bitcoin, Ethereum, Algorand, or USD fiat."}
                        thirdQuestion={"Is there a minimum or maximum investment amount?"}
                        thirdDescription={"Yes, there is a minimum and maximum investment for each sale round. That information will be announced at the start of each sales event."}
                        
                    
                    />
                }
                { section === 5 &&
                    <FaqsQuestions
                        firstQuestion={"Why should I  submit the form to be whitelisted?"}
                        firstDescription={"Because of regulations and technical aspects, we must confirm your eligibility and contact information."}
                        secondQuestion={"I have submitted the form but I didn't receive confirmation email"}
                        secondDescription={"Upon verifying your data, we will contact you by email within a few days. Please check your junk folder and mark the email as This is no Junk! Add our domain to your Safe senders and domains and/or add our email address token@gearchain.io to your webmail address book. If you still miss our emails, please contact us directly by sending an email to token@gearchain.io."}
                        
                    
                    />
                }
            </InnerContainer>
        </Container>
    </div>
  );
}

const Container = styled.div`
    display: flex;
    flex-direction: column;
    padding-left: ${({width})=> width * 0.1}px;
    padding-right: ${({width})=> width * 0.1}px;
    margin-top: 50px ;
    justify-content: center;
    align-items: center;
    padding-bottom: 100px;
`

const InnerContainer = styled.div`
    display: flex;
    color: ${colors.white};
    /* width: 90%; */

`

const Btn = styled.button`
    border: 0px;
    background-color: ${({color})=> color};
    color: ${colors.white};
    padding: 10px 30px;
    margin-left: 30px;
    border-radius: 5px;

    @media (max-width: 768px) {
        margin-left: 5px;
        margin-top: 10px;

    }
`

export default FAQS;
